import Vue from 'vue'
// import { store } from '../store/store.js'
import Router from 'vue-router'
const Dashboard = () => import('@/views/Dashboard')
const EditProfile = () => import('@/views/Auth/EditProfile');
// const LoginPage = () => import('@/views/Auth/Login')
const PageNotFound = () => import('@/views/Error/PageNotFound');
const VehicleMapping = () => import('@/views/Public/VehicleMapping');


import LoginPage from '@/views/Auth/Login'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
    // }
    {
      path : '/',
      redirect : '/login'
    },
    {
      path : '/login',
      name : 'Login',
      component : LoginPage,
      meta : {
        requiresAuth : false,
        production : true
      }
    },
    {
      path : '/vehicle-mapping',
      name : 'VehicleMapping',
      component : VehicleMapping,
      meta : {
        requiresAuth : false,
        production : true
      }
    },
    {
      path : '/profile/edit',
      name : 'EditProfile',
      component : EditProfile,
      meta : {
        requiresAuth : true,
        production : true
      }
    },
    {
      path : '/highlights',
      name : 'Highlights',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      }
    },
    // {
    //   path : '/dealer-service',
    //   name : 'DealerService',
    //   component : Dashboard,
    //   meta : {
    //     requiresAuth : true,
    //     production : false
    //   }
    // },
    // {
    //   path : '/dealer-registration-and-service',
    //   name : 'DealerRegistrationAndService',
    //   component : Dashboard,
    //   meta : {
    //     requiresAuth : true,
    //     production : true
    //   }
    // },
    {
      path : '/national-report',
      name : 'NationalReport',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      }
    },
    // {
    //   path : '/log/report',
    //   name : 'LogReport',
    //   component : Dashboard,
    //   meta : {
    //     requiresAuth : true,
    //     production : true
    //   },
    //   props: true
    // },
    // {
    //   path : '/log/report/:rquuid',
    //   name : 'LogReportDetails',
    //   component : Dashboard,
    //   meta : {
    //     requiresAuth : true,
    //     production : true
    //   },
    //   props: true
    // },
    {
      path : '/mapping/report',
      name : 'MappingReport',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      },
      props: true
    },
    {
      path : '/vehicle/detail',
      name : 'VehicleDetail',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      },
      props: true
    },
    {
      path : '/vehicle/incoming-pdc',
      name : 'IncomingPDC',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      },
      props: true
    },
    {
      path : '/vehicle/search/:frame_no',
      name : 'ObjectSearchDetail',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      },
      props: true
    },
    {
      path : '/user',
      name : 'UserManagement',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      },
      props: true
    },
    {
      path : '/user/:access/:id',
      name : 'EditUser',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      },
      props: true
    },
    {
      path : '/user/add',
      name : 'AddUser',
      component : Dashboard,
      meta : {
        requiresAuth : true,
        production : true
      },
      props: true
    },
    // {
    //   path : '/unmatch',
    //   name : 'UnmatchReport',
    //   component : Dashboard , 
    //   meta : {
    //     requiresAuth : true,
    //     production : true
    //   }
    // },
    // {
    //   path : '/vehicle/aging',
    //   name : 'AgingReport',
    //   component : Dashboard , 
    //   meta : {
    //     requiresAuth : true,
    //     production : true
    //   }
    // },
    // {
    //   path : '/vehicle/leadtime',
    //   name : 'LeadTime',
    //   component : Dashboard , 
    //   meta : {
    //     requiresAuth : true,
    //     production : true
    //   }
    // },
    // {
    //   path : '/replace-qr',
    //   name : 'ReplacedQR',
    //   component : Dashboard , 
    //   meta : {
    //     requiresAuth : true,
    //     production : true
    //   }
    // },
    {
      path : '/product-plan',
      name : 'ProductPlan',
      component :  Dashboard, 
      meta : {
        requiresAuth : true,
        production : true
      }
    },
    { 
      path: "*", 
      component: PageNotFound,
      meta : {
        requiresAuth : false,
        production : true
      }
    }

  ]
})

export default router;